import { render, staticRenderFns } from "./FileInputForm.vue?vue&type=template&id=6b83e782&"
import script from "./FileInputForm.vue?vue&type=script&lang=js&"
export * from "./FileInputForm.vue?vue&type=script&lang=js&"
import style0 from "./FileInputForm.vue?vue&type=style&index=0&id=6b83e782&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports